<div class="icon-text-button-wrapper"
  [class.cursor-disabled]="disabled"
  [class.cursor-loading]="loading"
  (click)="disabled || loading ? $event.stopPropagation() : {}">
  <button matRipple
    class="icon-text-button"
    [class]="panelClass"
    [ngClass]="['color-' + color, 'type-' + type, 'size-' + size]"
    [class.button-disabled]="disabled"
    [class.button-loading]="loading">
    @if (icon && !loading) {
      <img [src]="icon" class="button-icon" alt="" />
    }
    @if (loading) {
      <app-spinner class="button-spinner" [color]="'grey'" [scale]="0.4"></app-spinner>
    }
    <span class="button-text" [style.visibility]="loading ? 'hidden' : 'visible'">
      <ng-content></ng-content>
    </span>
  </button>
</div>






